import { Box, CircularProgress } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { RosterLookup } from "@/hooks/useRosterLookup";
import { SystemBanner } from "@/ui/molecules/SystemBanner";

type Props = { roster: Pick<RosterLookup, "isLoading" | "isError">; dataTestId: string };

/**
 * What a screen built on the staff list shows before it has it: a spinner while it loads, the failure when it didn't,
 * and nothing once it's in — so a failed load never reads as "no staff".
 */
export const RosterLoadFallback: FC<Props> = ({ roster, dataTestId }) => {
	const { t } = useTranslation();
	if (roster.isLoading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", p: 4 }} data-testid={`${dataTestId}-roster-loading`}>
				<CircularProgress />
			</Box>
		);
	}
	if (!roster.isError) return null;
	return <SystemBanner tone="error" title={t("profile.roster.unavailable")} sx={{ m: 2 }} dataTestId={`${dataTestId}-roster-error`} />;
};
